import React from 'react';
import styled from 'styled-components';

const ContactPageContainer = styled.div``;

const ContentSection = styled.section`
  max-width: 800px;
  margin: 4rem auto;
  padding: 0 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 2.5rem;
  color: #333;
  text-align: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  text-align: left;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #444;
`;

const Input = styled.input`
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    outline: none;
    border-color: #005eb8;
    box-shadow: 0 0 0 2px rgba(0, 94, 184, 0.2);
  }
`;

const Textarea = styled.textarea`
  padding: 12px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    outline: none;
    border-color: #005eb8;
    box-shadow: 0 0 0 2px rgba(0, 94, 184, 0.2);
  }
`;

const SubmitButton = styled.button`
  padding: 15px 20px;
  background-color: #005eb8;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: bold;
  transition: background-color 0.3s;
  align-self: flex-start;

  &:hover {
    background-color: #004a94;
  }
`;

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic will go here in the future
    alert('Thank you for your message!');
  };

  return (
    <ContactPageContainer>
      <ContentSection>
        <Title>Contact Us</Title>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="fullName">Full Name</Label>
            <Input type="text" id="fullName" name="fullName" required />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="subject">Subject</Label>
            <Input type="text" id="subject" name="subject" required />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="email">Email Address</Label>
            <Input type="email" id="email" name="email" required />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="phone">Phone Number</Label>
            <Input type="tel" id="phone" name="phone" />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="message">Message</Label>
            <Textarea id="message" name="message" required />
          </FormGroup>
          <SubmitButton type="submit">Send Message</SubmitButton>
        </Form>
      </ContentSection>
    </ContactPageContainer>
  );
};

export default Contact;